import { HTMLAttributes, ReactNode } from "react";

/**
 * Eyebrow — Archival Studio primitive.
 *
 * Mono uppercase label that runs above section headings, before
 * timestamps, signatures, hash digests, gate identifiers. The
 * "proof gate" voice of the design system.
 *
 *   <Eyebrow>Chapter 04 · 4,212 words</Eyebrow>
 *   <Eyebrow withDot>System status</Eyebrow>
 */

interface EyebrowProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  /** Render a small walnut dot before the label (used in section headers). */
  withDot?: boolean;
}

export function Eyebrow({ children, withDot = false, className = "", ...rest }: EyebrowProps) {
  return (
    <span
      className={
        "inline-flex items-center gap-[8px] " +
        "font-mono text-[11px] tracking-as-eyebrow uppercase text-ink-3 " +
        className
      }
      {...rest}
    >
      {withDot && <span className="w-[6px] h-[6px] rounded-full bg-walnut" />}
      {children}
    </span>
  );
}
